import React, { useCallback, useEffect } from 'react';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  IconButton,
} from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';
import { Schema } from 'yup';
import clsx from 'clsx';
import useStyles from './styles';
import { ItemFormReact } from '..';
import { TimesIcon } from '../icon/solid';
import FormSubmit from '../form-submit/ReactFormSubmit';
import FormReset from '../form-reset/ReactFormReset';
import { useId } from '../../hooks';

/* eslint-disable @typescript-eslint/no-explicit-any, no-nested-ternary */

type Props = {
  open: boolean;
  form: {
    data: any;
    validationSchema: Schema<unknown>;
    onSubmit: (values: any) => void;
    creatingMode?: boolean;
  };
  title: React.ReactNode;
  component: React.ReactNode;
  onCloseHandler: () => void;
  submitTitle?: React.ReactNode;
  onMountToggleAction?: () => void;
};

const ReactFormModal = ({
  open,
  form,
  title,
  component,
  onCloseHandler,
  submitTitle,
  onMountToggleAction,
}: Props) => {
  const id = useId();
  const classes = useStyles();

  const submitHandler = useCallback((data: any) => {
    form.onSubmit(data);
  }, [form]);

  useEffect(() => {
    if (onMountToggleAction) {
      onMountToggleAction();
    }

    return () => {
      if (onMountToggleAction) {
        onMountToggleAction();
      }
    };
  }, [onMountToggleAction]);
  return (
    <Dialog
      open={open}
      onEscapeKeyDown={onCloseHandler}
      aria-labelledby={id}
      disableBackdropClick
      PaperProps={{ className: classes.modal }}
      fullWidth
      style={{ zIndex: 2147483100 }}
    >
      <DialogTitle id={id}>
        {title}
        <IconButton aria-label="close" className={classes.closeButton} onClick={onCloseHandler}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <ItemFormReact
        loading={false}
        initialValues={form.data}
        validationSchema={form.validationSchema}
        onSubmit={submitHandler}
        hideActions
      >
        <DialogContent className={classes.dialogContent}>
          {component}
        </DialogContent>
        <DialogActions className={classes.dialogActions}>
          <FormReset
            className={clsx(classes.cancelButton, classes.panelButton)}
            variant="contained"
            color="default"
            withHotkey
            closeDialog={onCloseHandler}
          >
            <TimesIcon className={classes.buttonIcon} />
            <span className={classes.buttonText}>Cancel</span>
          </FormReset>
          <FormSubmit
            className={classes.panelButton}
            variant="contained"
            color="primary"
          >
            <span className={classes.buttonText}>
              {submitTitle || form.creatingMode ? 'Create' : 'Save'}
            </span>
          </FormSubmit>
        </DialogActions>
      </ItemFormReact>
    </Dialog>
  );
};

export default ReactFormModal;
